module.exports = __webpack_public_path__ + "img/music-slash.01f4eed1.svg";